"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _EditLayerForm = _interopRequireDefault(require("../EditLayerForm/EditLayerForm"));

var _common = require("../../../../../util/common");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["source"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var EditDefaultLayerForm = function EditDefaultLayerForm(_ref) {
  var layer = _ref.layer,
      onFinish = _ref.onFinish;
  var onInternalFinish = (0, _react.useCallback)(function (values) {
    var source = values.source,
        properties = _objectWithoutProperties(values, _excluded);

    (0, _common.normalizeStringInObject)(properties);
    layer.setProperties(properties); //execute onFinish

    onFinish && onFinish(values);
  }, [layer, onFinish]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditLayerForm.default, {
    layer: layer,
    onFinish: onInternalFinish
  });
};

var _default = EditDefaultLayerForm;
exports.default = _default;